import { Typography } from "../../wsui/base";

import useFormField from "./useFormField";

export default function FormFieldDescription({ ...restProps }) {
  const { description, id } = useFormField();
  if (!description) {
    return null;
  }
  return (
    <Typography variant="description" id={`${id}-description`} {...restProps}>
      {description}
    </Typography>
  );
}
